<template>
  <div class="container page">
    <van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
      <template #right>
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">
          {{ $t("withdraw.with_record") }}
        </span>
      </template>
    </van-nav-bar>

    <div class="main">
      <!-- 余额展示卡片 -->
      <div class="balance-card">
        <div class="title">{{ $t("my.balance") }}</div>
        <div class="amount">{{ userInfo.money || '0.00' }}</div>
      </div>

      <!-- 提现输入卡片 -->
      <van-cell-group inset class="modern-card">
        <!-- 提现金额 -->
        <van-field
          v-model="withdraw_money"
          type="number"
          label-align="top"
          :label="$t('withdraw.with_money')"
          :placeholder="$t('reservation.unit')"
          left-icon="balance-o"
        >
          <template #button>
            <van-button size="small" class="all-btn" @click="allMoney">
              {{ $t("index.all") }}
            </van-button>
          </template>
        </van-field>

        <!-- 提现密码 -->
        <van-field
          v-model="withdraw_password"
          type="password"
          label-align="top"
          :label="$t('my.balance_passw')"
          :placeholder="$t('my.balance_passw')"
          left-icon="lock"
        />
      </van-cell-group>

      <!-- 提交按钮 -->
      <div class="action-btn">
        <van-button 
          round 
          block 
          type="info" 
          :loading="loading" 
          class="submit-btn" 
          @click="doWithdraw"
        >
          {{ $t("withdraw.immediately_withdraw") }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      withdraw_money: "",
      withdraw_password: "",
      userInfo: {},
      withdrawRole: {},
      loading: false,
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserWithdrawRole() {
      this.$http({ method: 'get', url: 'user_get_withdraw_role' }).then(res => {
        if (res.code === 200) {
          this.withdrawRole = res.data;
        }
      });
    },
    allMoney() {
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw() {
      if (Number(this.userInfo.reputation || 0) < 100) {
        this.$toast.fail('信誉分低，无法提款');
        return false;
      }
      if (!this.withdraw_money || this.withdraw_money <= 0) {
        this.$toast.fail(this.$t("setting.correct_money"));
        return false;
      }
      this.loading = true;
      this.$http({
        method: 'post',
        data: {
          money: this.withdraw_money,
          withdraw_password: this.withdraw_password,
        },
        url: 'user_set_withdraw'
      }).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.$toast.success(res.msg);
          this.withdraw_money = "";
          this.withdraw_password = "";
          this.getUserInfo();
        } else {
          this.$toast.fail(res.msg);
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.main {
  background-color: #f2f2f5;
  min-height: 100vh;
  padding: 20px 0;
}

/* 余额卡片 */
.balance-card {
  background: linear-gradient(135deg, #e6c3a1, #7e5678);
  color: #fff;
  margin: 0 20px 20px;
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  .title { font-size: 28px; opacity: 0.9; }
  .amount { font-size: 60px; font-weight: bold; margin-top: 10px; }
}

/* 输入表单卡片 */
.modern-card {
  margin: 0 20px !important;
  padding: 10px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);

  ::v-deep .van-field__label {
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
    font-size: 28px;
  }

  ::v-deep .van-cell {
    padding: 25px 15px;
    font-size: 30px;
  }
}

/* 按钮样式 */
.action-btn {
  padding: 0 40px;
  margin-top: 50px;
}

.submit-btn {
  height: 90px;
  font-size: 32px;
  font-weight: bold;
  background: linear-gradient(90deg, #e6c3a1, #7e5678);
  border: none;
}

.all-btn {
  background: linear-gradient(90deg, #e6c3a1, #7e5678);
  border: none;
  color: #fff;
  border-radius: 8px;
  padding: 0 20px;
}
</style>
